import { STAGE_META, TONES } from './trackingUtils'

/** Pill for a shipment stage, e.g. "Out for delivery". */
export default function StatusBadge({ stage }) {
  const meta = STAGE_META[stage] ?? STAGE_META.unknown
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-[10px] font-bold tracking-wider uppercase ${TONES[meta.tone]}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" aria-hidden="true"></span>
      {meta.label}
    </span>
  )
}
